var _ = require('underscore');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
  new Columnator();
  new IndexView();

  $('.primary-selector').change(_.debounce(function () {
    let form = $(this).siblings('form');

    if (form) {
      form.submit();
    }
  }, 200));
};
